<template>
  <div class="h-full overflow-hidden" v-loading="tableLoading || lineLoading">
    <div class="pl-15px mt-10px mb-10px text-[#fff] text-14px">
      <div class="mb-10px">设备名称：{{ deviceIfo.name }}</div>
      <div>设备编码：{{ deviceIfo.code }}</div>
    </div>
    <el-table
      :data="tableData"
      :height="`calc(100% - 320px)`"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column label="" width="20">
        <template>
          <div class="selected-row"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pointName" label="测点名称" min-width="80"></el-table-column>
      <el-table-column prop="value1" label="实时数据" min-width="40"></el-table-column>
    </el-table>
    <categoryTitle class="mt-10px mb-10px" title="测点趋势信息" />
    <div class="h-250px w-full">
      <v-chart
        class="w-full h-full"
        :options="chartOptions"
        :autoresize="true"
        :init-options="{ devicePixelRatio: 2 }"
      ></v-chart>
    </div>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { DevicePointRelationApi } from '@wiz-api/tag-management'
import { IotApi } from '@wiz-api/measuring-point-management'

const devicePointRelationApi = new DevicePointRelationApi()
const iotApi = new IotApi()
const signalR = require('@microsoft/signalr')

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    categoryTitle,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      connection: null,
      tableLoading: false,
      deviceIfo: {},
      tableData: [],
      chartLine: null,
      lineLoading: false,
      chartOptions: {
        animation: false,
        color: [
          '#3CD495',
          '#5FD5EC',
          '#2276FC',
          '#3f51b5',
          '#e51c23',
          '#009688',
          '#259b24',
          '#ff9800',
          '#8129bd',
          '#b5c334',
          '#fcce10',
          '#e87c25',
          '#27727b',
        ],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: 12 },
          confine: true,
          borderWidth: 1,
          borderColor: '#35d0dd',
          backgroundColor: 'rgba(17,83,71,0.8)',
          formatter: (params) => {
            let formatStr = `${this.dayjs(params[0].data[0]).format('YYYY-MM-DD HH:mm:ss')}<br/>`
            _.forEach(params, (item) => {
              formatStr = `${formatStr}${item.marker}${item.seriesName}: ${item.data[1] ||
                '--'}<br/>`
            })
            return formatStr
          },
        },
        legend: {
          data: [],
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '25',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'time',
          splitLine: { show: false },
          axisLabel: {
            color: '#fff9',
            fontSize: 12,
            showMinLabel: true,
            showMaxLabel: true,
            formatter: (value) => {
              return this.dayjs(value).format('HH:mm:ss')
            },
          },
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#ffffff4d', fontSize: 12 } },
        },
        yAxis: {
          type: 'value',
          splitArea: { show: false },
          splitLine: { lineStyle: { color: ['rgba(255,255,255,0.05)'], type: 'dashed' } },
          axisTick: { show: false },
          axisLabel: { color: '#fff9', fontSize: 12 },
          axisLine: { show: false, lineStyle: { color: '#ffffff4d' } },
        },
        series: [],
      },
    }
  },
  watch: {
    transferProps: {
      async handler(data) {
        if (this.deviceIfo.code === data?.code) return
        this.deviceIfo = data || {}
        if (this.deviceIfo.code) {
          await this.removeAllDot()
          this.chartOptions.series = []
          this.chartOptions.xAxis.data = []
          this.chartOptions.legend.data = []
          this.tableData = []
          this.getLinkPointList()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // websocket路径
    websocketServer() {
      return Wiz.GetModuleServer('visualization-cockpit')
    },
  },
  methods: {
    // 获取关联测点列表
    async getLinkPointList() {
      this.tableLoading = true
      const [err, res] = await devicePointRelationApi.getList({
        deviceCode: this.deviceIfo.code,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        res.items.forEach((item) => {
          item.value1 = '--'
        })
        this.tableData = res.items || []
      }
      this.tableLoading = false
      if (this.tableData.length > 0) {
        this.getMeasurePointTrend()
      }
    },
    // 获取测点趋势图
    async getMeasurePointTrend() {
      this.lineLoading = true
      const end = new Date().getTime()
      const start = end - 1000 * 60 * 10
      const startTimeStamp = Number((start / 1000).toFixed(0))
      const endTimeStamp = Number((end / 1000).toFixed(0))
      // console.log(this.dayjs(startTimeStamp * 1000).format('YYYY-MM-DD HH:mm:ss'), 'dayjs(startTimeStamp)')
      // console.log(this.dayjs(endTimeStamp * 1000).format('YYYY-MM-DD HH:mm:ss'), 'dayjs(endTimeStamp)')
      const pointIds = this.tableData.map((item) => {
        return String(item.pointId)
      })
      const pointNames = this.tableData.map((item) => {
        return item.pointName
      })
      const [err, res] = await iotApi.getDivideValueListForMeasuringPoints({
        body: {
          interval: 10,
          ids: pointIds,
          startTimeStamp,
          endTimeStamp,
          maxResultCount: 1000,
          skipCount: 0,
        },
      })
      if (!err) {
        const parseRes = JSON.parse(res.data).reverse()
        const graphData = {}
        const seriesArr = []
        pointIds.forEach((pointId, index) => {
          graphData[`graphData${index + 1}`] = parseRes.map((scatterData) => {
            const val = scatterData[pointId] ? Number(scatterData[pointId]).toFixed(2) : '--'
            return [scatterData.time * 1000, val]
          })
        })
        const graphDataArr = Object.keys(graphData)
        graphDataArr.forEach((ite, index) => {
          const processData = graphData[ite]
          seriesArr.push({
            titleSort: `${index + 1}`,
            type: 'line',
            name: pointNames[index],
            pointId: pointIds[index],
            data: processData,
            showSymbol: false, // 隐藏拐点
          })
        })
        this.chartOptions.legend.data = pointNames
        this.chartOptions.series = seriesArr
      }
      this.lineLoading = false
      const measuringPointIds = this.tableData.map((item) => {
        return {
          MeasuringPointId: String(item.pointId),
        }
      })
      await this.connection?.invoke('BulkAddDto', measuringPointIds)
    },
    // 清空订阅测点
    async removeAllDot() {
      try {
        await this.connection?.invoke('RemoveAllDto')
      } catch (e) {
        // throw e
      }
    },
    // 建立面板连接
    async initConenction() {
      // 建立连接
      const url = `${this.websocketServer}/iotQueryForJobManageHub`
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        .build()

      console.log('connection created', this.connection)
      // 监听面板测点信息
      this.connection.on('MsgResult', (data) => {
        console.log('panel MsgResult', data)
        const pointIdMap = {}
        data.forEach((item) => {
          item.time = this.dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')
          pointIdMap[item.measuringPointId] = item
        })

        // 更新表格数据
        const tableData = [...this.tableData]
        tableData.forEach((item) => {
          if (pointIdMap[item.pointId]) {
            const val = pointIdMap[item.pointId].value?.toFixed(2)
            item.value1 = `${val}${item.pointUnit || ''}`
          }
        })
        this.tableData = [...tableData]
        // 更新图表数据
        const time = this.dayjs().format('YYYY-MM-DD HH:mm:ss')
        this.chartOptions.series.forEach((item) => {
          const pointId = item.pointId
          if (pointIdMap[pointId]) {
            const val = pointIdMap[item.pointId].value?.toFixed(2)
            item.data.push([time, `${val}`])
          } else {
            item.data.push([time, null])
          }
          item.data.shift()
        })
      })

      this.connection.onclose(() => {
        console.log('connection closed')
        this.connection = null
      })

      // 开始连接
      try {
        await this.connection.start()
      } catch (e) {
        console.log('connection error', e)
      }
    },
  },
  created() {
    this.initConenction()
  },
  async beforeDestroy() {
    try {
      await this.connection?.invoke('DisconnectedCurrentHub')
      this.connection = null
    } catch (e) {
      // throw e
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}
</style>
